import React from "react";

const Clock = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36", isRegular = false}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            stroke={fill || "#4E525F"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3.111}
            d="M4.25 18.25a14 14 0 1 0 28 0 14 14 0 0 0-28 0Z"
        />
        <path
            stroke={fill || "#4E525F"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={3.111}
            d="M18.25 10.472v7.778l4.667 4.666"
        />
    </svg>
);

export default Clock;
